/* eslint-disable no-undef */
// External script provided by a third party
import initCommerceEmbeddedMessaging from './CommerceEnhancedChatScript';

const samedaySalesForceChat = () => ({
  showChatWindow() {
    window?.embeddedservice_bootstrap?.utilAPI?.removeAllComponents();
    if (!Array.from(document.scripts).some((s) => s.src && s.src.includes(process.env.REACT_APP_COMMERCE_SALESFORCE_EMBEDDED_ID))) {
      const s = document.createElement('script');
      s.setAttribute('src', process.env.REACT_APP_COMMERCE_SALESFORCE_EMBEDDED_SERVICE);
      s.onload = () => {
        initCommerceEmbeddedMessaging();
        setTimeout(() => {
          window.embeddedservice_bootstrap.bootstrapEmbeddedMessaging();
        }, 2000);
      };
      document.body.appendChild(s);
    } else {
      initCommerceEmbeddedMessaging();
      setTimeout(() => {
        window.embeddedservice_bootstrap.bootstrapEmbeddedMessaging();
      }, 2000);
    }
  }
});

export default samedaySalesForceChat;
